import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  geScheduleDetails_Level1,
  geScheduleDetails_Level2,
} from "../../Services/Schedule/schedule";

export const fetchSchedule = createAsyncThunk("schedule/get", async (id) => {
  try {
    let response = await geScheduleDetails_Level1(id);
    return response?.data?.data || [];
  } catch (err) {
    throw err;
  }
});

export const fetchScheduleLevel2 = createAsyncThunk(
  "schedule/id",
  async (id) => {
    try {
      let response = await geScheduleDetails_Level2(id);
      return response?.data?.data || [];
    } catch (err) {
      throw err;
    }
  }
);

const scheduleSlice = createSlice({
  name: "past",
  initialState: {},
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSchedule.pending, (state) => {
        state.error = null;
      })
      .addCase(fetchSchedule.fulfilled, (state, action) => {
        state.list = action.payload?.page || [];
      })
      .addCase(fetchSchedule.rejected, (state, action) => {
        state.error = action.error.message;
      });
    builder
      .addCase(fetchScheduleLevel2.pending, (state) => {
        state.error = null;
      })
      .addCase(fetchScheduleLevel2.fulfilled, (state, action) => {
        state.list_l2 = action.payload || [];
      })
      .addCase(fetchScheduleLevel2.rejected, (state, action) => {
        state.error = action.error.message;
      });
  },
});

export default scheduleSlice.reducer;
